import React from "react";
import QuestionTypeFilter from "./QuestionTypeFilter";
import QuestionSortType from "./QuestionSortType";
import LocationDropdown from "./LocationDropdown";

/*
  DashboardFilters
  -----------------
  Temporary shell component to host upcoming sort / filter controls.
  Layout: one row, three equal columns. Each column will later contain
  its own focused control component (e.g., SortSelect, TopicFilter, YearFilter).

  For now we just render structural placeholders and keep the future
  components commented out so this can be safely merged without adding logic.
*/

const DashboardFilters = ({
  questionType,
  onQuestionTypeChange,
  questionSortType,
  onQuestionSortTypeChange,
  // location props optional
  location,
  locations,
  displayLocations,
  displayLocationDropdown,
  onLocationChange,
  setLocationSelectedFromDropdownMenu,
}) => {
  return (
    <div
      className="d-flex mt-3 mb-2 align-items-center justify-content-between"
      aria-label="dashboard filters"
      id="dashboard-filters"
      style={{ width: '100%' }}
    >
      <div className="mb-2" style={{ flex: '1 1 0', minWidth: 0 }}>
        <QuestionTypeFilter value={questionType} onChange={onQuestionTypeChange} />
      </div>
      <div className="mb-2 d-flex justify-content-center" style={{ flex: '1 1 0', minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <QuestionSortType questionSortType={questionSortType} onChange={onQuestionSortTypeChange} />
        </div>
      </div>
      <div className="mb-2 d-flex justify-content-end" style={{ flex: '1 1 0', minWidth: 0 }}>
        {locations && locations.length > 0 ? (
          <div style={{ width: '100%' }}>
              <LocationDropdown
                displayLocations={displayLocations}
                displayLocationDropdown={displayLocationDropdown}
                location={location}
                locations={locations}
                onLocationChange={onLocationChange}
                setLocationSelectedFromDropdownMenu={setLocationSelectedFromDropdownMenu}
              />
          </div>
        ) : (
          <div className="p-3 border rounded text-muted small bg-light">Location loading…</div>
        )}
      </div>
    </div>
  );
};

export default DashboardFilters;
